var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStellarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1438.2 223",
    style: {
      enableBackground: "new 0 0 1438.2 223"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    className: "st0",
    d: "M148.1,74.8l-0.1,33.2l-66.1,66.2H48L126.7,96L148.1,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    className: "st0",
    d: "M73.6,133l-16.7,16.7l-0.1-0.1l-13-12.9l-2.1-2.1l-10-9.9l-8.5-8.5l-2.6-2.7L8.9,101.9l-0.7-0.7 L8.4,4.8l23.4,23.3l0.1,51.4v1.1l0,10.7l41.6,41.6L73.6,133z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    className: "st0",
    d: "M73,11.3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    className: "st0",
    x1: 43.3,
    y1: 11.3,
    x2: 43.3,
    y2: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    className: "st0",
    d: "M98.5,107.9l-1,1l-14.9,14.9l-0.9,0.9l-2.9-2.8l-2.1-2.1l-10-9.9l-8.5-8.5l-2.6-2.7L44,87 l-0.7-0.7l0.1-33.6l0,0v-2.5l0,0l0.1-45.6L66.8,28l0.1,21.3l0,0v4.3l0,0l0,11l0,0v1l0,10.7L98.5,107.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    className: "st0",
    d: "M123.5,82.9l-2.7,2.7l-11.5,11.5l-2.6,2.6l-4.8-4.7l-8.5-8.5l-2.6-2.7L79.1,72.1l-0.7-0.7 l0.1-66.9L102,27.8l0.1,21.9l0,0v1l0,10.7L123.5,82.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(32.374 6.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    className: "st0",
    d: "M138.6,149.1l18.9-14.8c6.2,9.5,16.6,15.4,28,15.9c10.7,0,18.1-5.5,18.1-14.5 c0-6.6-5.8-10.1-14.7-15.5l-11.9-7.3c-11.4-7.1-18.8-16.1-18.8-31.4c0-21.6,19.5-39,44.2-39c14.9,0.3,28.8,7.3,38,19L223.8,77 c-5.5-6.9-13.7-11.2-22.6-11.8c-10.4,0-16,6.3-16,13.5c0,6.5,5.9,9.6,15.7,15.7l12.4,7.6c12.1,7.3,17.5,15.3,17.5,29.8 c0,22.8-18.7,40.8-47.5,40.8C165.5,172.8,148.7,163.9,138.6,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    className: "st0",
    d: "M251.6,147.4c0.1-4,0.6-8.1,1.4-12l8.4-40h-12.7l3.9-19.5l14.1-1.1l8.1-25h22.1l-4.8,25h21.6 l-4,20.6h-22.3l-8.3,41c-0.3,2.1-0.5,4.2-0.5,6.4c0,6.3,3.1,9.4,10,9.4c2.7-0.1,5.4-0.9,7.8-2.2l4.8,18.5 c-7.2,2.8-14.8,4.2-22.4,4.2C259.4,172.7,251.6,162,251.6,147.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    className: "st0",
    d: "M366.5,72.5c22.8,0,31.2,16,31.2,35.9c-0.2,7.5-1.8,14.9-4.9,21.8h-54.5 c-0.7,15.9,8.9,22.7,21.5,22.7c6.4-0.5,12.5-2.8,17.5-6.7l9.4,16.6c-10.1,6.8-22.1,10.2-34.3,10c-23.1,0-39.1-15.3-39.1-40.9 C313.4,96.4,341.1,72.5,366.5,72.5z M375.2,114c0.5-2.3,0.8-4.7,0.8-7.1c0-7.7-3.2-14.1-12.8-14.1c-9.1,0-18.4,7.2-22.8,21.3 H375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    className: "st0",
    d: "M410.4,154c0-3.9,0.5-7.8,1.4-11.7l21.4-106.9h26.4l-21.7,107.9c-0.3,1.2-0.4,2.5-0.4,3.7 c0,3.3,1.7,4.4,3.6,4.4c1.2,0,2.3-0.1,3.4-0.5l-0.8,19.5c-4.5,1.5-9.2,2.2-14,2.1C416,172.7,410.4,165.6,410.4,154z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    className: "st0",
    d: "M463.4,154c0-3.9,0.5-7.8,1.4-11.7l21.4-106.9h26.3l-21.7,107.9c-0.3,1.2-0.4,2.5-0.4,3.7 c0,3.3,1.7,4.4,3.6,4.4c1.2,0,2.3-0.1,3.4-0.5l-0.8,19.5c-4.5,1.5-9.2,2.2-14,2.1C469,172.7,463.4,165.6,463.4,154z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    className: "st0",
    d: "M515.3,137.6c0-36.4,24.7-65.2,51-65.2c8.7,0,16.8,4.8,20.8,12.6h0.5l4.1-10.2h21.1l-19.1,95.6 h-21.4l0.4-12.5h-0.5c-7.7,8.6-18.4,14-29.9,14.8C525.4,172.7,515.3,160.2,515.3,137.6z M574.2,137l6.8-33.9 c-2.2-5.3-7.2-8.8-12.8-9.2c-13.3,0-25.6,17.5-25.6,40.3c0,11.7,4.3,16.9,11.2,16.9C560.1,151.2,568,147.9,574.2,137L574.2,137z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    className: "st0",
    d: "M637.2,74.8h21.4l-1.2,18.6h0.8c7.4-12.1,18.2-20.9,29.2-20.9c3.4-0.2,6.9,0.4,10,1.9l-8.7,22.9 c-3-1.2-6.2-1.8-9.5-1.5c-8.4,0-16.3,5.9-23.8,19.4l-10.7,55.4h-26.4L637.2,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    className: "st0",
    d: "M758.4,44.8h26.4L764,148.2h47.6l-4.3,22.2h-74.1L758.4,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    className: "st0",
    d: "M826.6,137.6c0-36.4,24.7-65.2,51-65.2c8.7,0,16.8,4.8,20.8,12.6h0.5l4.1-10.2h21.1L905,170.4 h-21.4l0.4-12.5h-0.5c-7.7,8.6-18.4,14-29.9,14.8C836.8,172.7,826.6,160.2,826.6,137.6z M885.5,137l6.8-33.9 c-2.2-5.3-7.2-8.8-12.8-9.2c-13.3,0-25.6,17.5-25.6,40.3c0,11.7,4.3,16.9,11.2,16.9C871.5,151.2,879.3,147.9,885.5,137L885.5,137z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    className: "st0",
    d: "M948.5,74.8H970l-0.4,12.8h0.8c9.3-8.1,20.1-15.1,32.2-15.1c15.8,0,22.6,8.6,22.6,24.6 c0,4.6-0.6,9.1-1.5,13.6l-12,59.7h-26.3l11.3-56.4c0.8-3,1.3-6.1,1.5-9.2c0.7-4.8-2.7-9.2-7.5-9.8c-0.7-0.1-1.5-0.1-2.3,0 c-5.9,0-11.8,3.9-20.1,12.5l-12.3,62.9h-26.4L948.5,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    className: "st0",
    d: "M1112.6,65.9l5.9-30.5h26.4l-27.2,135h-21.4l0.4-12.5h-0.5c-7.7,8.6-18.4,14-29.9,14.8 c-16.8,0-27-12.5-27-35c0-36.4,24.7-65.2,51-65.2c8.2-0.1,15.7,4.4,19.5,11.6h0.5L1112.6,65.9z M1098.2,137l6.8-33.9 c-2.2-5.3-7.2-8.8-12.8-9.2c-13.3,0-25.6,17.5-25.6,40.3c0,11.7,4.3,16.9,11.2,16.9C1084.2,151.2,1091.7,147.9,1098.2,137 L1098.2,137z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    className: "st0",
    d: "M1160.4,74.8h26.4l-19.1,95.6h-26.3L1160.4,74.8z M1164.3,47.8c0.3-8.8,7.6-15.8,16.5-15.6 c7.3-0.6,13.7,4.8,14.3,12.1c0,0.2,0,0.4,0,0.6c-0.1,8.7-7.2,15.7-15.9,15.6c-0.2,0-0.4,0-0.6,0c-7.2,0.7-13.5-4.5-14.2-11.7 C1164.3,48.5,1164.3,48.1,1164.3,47.8L1164.3,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    className: "st0",
    d: "M1211.1,74.8h21.4l-0.4,12.8h0.8c9.3-8.1,20.1-15.1,32.2-15.1c15.8,0,22.6,8.6,22.6,24.6 c0,4.6-0.6,9.1-1.5,13.6l-11.9,59.7h-26.4l11.3-56.4c0.8-3,1.3-6.1,1.5-9.2c0.7-4.8-2.7-9.2-7.5-9.8c-0.7-0.1-1.5-0.1-2.3,0 c-5.9,0-11.8,3.9-20.1,12.5l-12.3,62.9h-26.4L1211.1,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    className: "st0",
    d: "M1293.6,198l11.4-17.6c6.9,6,15.5,9.5,24.6,10.1c12.5,0,20.9-7,24.6-20l4.9-17 c-7.5,8.4-18.1,13.4-29.4,13.8c-16.1,0-27.9-10.9-27.9-33.4c0-34.3,23.7-61.5,49.9-61.5c8.6,0,16.6,4.8,20.5,12.6h0.5l4.1-10.2 h21.4l-18.8,94c-5.7,28.3-23.8,42.5-50.6,42.5C1315.9,210.9,1303.5,206.2,1293.6,198z M1360.3,133.5l5.9-30.3 c-2.1-5.2-6.9-8.8-12.5-9.2c-13.1,0-24.4,15.9-24.4,36.6c0,10.4,4.3,15.2,10.8,15.2C1348.5,145.5,1356.2,140.9,1360.3,133.5 L1360.3,133.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStellarIcon);
export default __webpack_public_path__ + "static/media/stellar-icon.ea48dc31f3914c1099b8804480e3e389.svg";
export { ForwardRef as ReactComponent };